import { useEffect, useState } from 'react';
import { Button } from '@iwoca/orion';
import { Trans } from '@lingui/react/macro';
import { useDashboard } from 'components/Dashboard/Dashboard.context';
import { UseFormSetValue } from 'react-hook-form';
import { TSearchBarFormData } from 'types';
import styles from './RecentSearches.module.css';

export const LOCAL_STORAGE_KEY = 'recentSearches';

type TProps = {
  setValue: UseFormSetValue<TSearchBarFormData>;
};

export const RecentSearches = ({ setValue }: TProps) => {
  const { searchApplication } = useDashboard();
  const [storageItems, setStorageItems] = useState([]);
  const [hasRecentSearch, setHasRecentSearch] = useState(false);

  useEffect(() => {
    const recentSearchItems = localStorage.getItem(LOCAL_STORAGE_KEY);
    if (recentSearchItems) {
      const recentSearchItemsParsed = JSON.parse(recentSearchItems);
      const recentSearchItemFiltered = recentSearchItemsParsed
        .filter((item: string) => item !== null)
        .filter((item: string, pos: number, self: string) => {
          return self.indexOf(item) === pos;
        });
      const recentSearchItemsReversed = recentSearchItemFiltered.reverse();
      const recentFiveSearchItems = recentSearchItemsReversed.splice(0, 6);
      setStorageItems(recentFiveSearchItems);
      setHasRecentSearch(true);
    }
  }, []);

  const handleButtonClick = (item: string) => {
    setValue('searchString', item);
    searchApplication(item);
  };

  return (
    <>
      {hasRecentSearch && (
        <div
          className={styles.dropdown}
          data-testid="recently-searched-dropdown"
        >
          <header className={styles.header}>
            <Trans>Recently searched</Trans>
          </header>
          <div className={styles.container}>
            {storageItems.map((item: string, index) => {
              return (
                <Button
                  className={styles.button}
                  variant="tertiary"
                  size="small"
                  type="button"
                  key={index}
                  onClick={() => handleButtonClick(item)}
                >
                  <div className={styles.buttonText}>{item}</div>
                </Button>
              );
            })}
          </div>
        </div>
      )}
    </>
  );
};
